export class FindAllTables {
  public static readonly type = '[Project/Tables/List] FindAllTables';
}
